<template>
    <div>
        <div class="card-content-search">
            <button class="card-content-search-add" v-debounce="[saveData,'click',500]"><i class="el-icon-plus" style="margin: 0 5px"></i>新增</button>
        </div>
        <div class="card-content-table">
            <el-table
                    border
                    :data="ruleForm.tableList"
                    align="center"
                    style="width: 100%"
                    ref="table"
                    :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                    }"
                    :row-key="getRowKeys"
                    :expand-row-keys="expands">
                <el-table-column
                        label="序号"
                        type="index"
                        align="center"
                        width="50">
                    <template scope="scope">
                        <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="人员姓名"
                        align="center"
                        prop="personnelName">
                    <template scope="scope">
                        <p>{{scope.row.personnelName || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="证件号码"
                        align="center"
                        width="190"
                        prop="empCret">
                    <template scope="scope">
                        <p>{{scope.row.empCret || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="奖惩类型"
                        align="center"
                        prop="recordTypeName">
                    <template scope="scope">
                        <p>{{scope.row.recordTypeName || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="处理文件文号"
                        align="center"
                        prop="fileNum">
                    <template scope="scope">
                        <p>{{scope.row.fileNum || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="实施/认定部门"
                        align="center"
                        prop="department">
                    <template scope="scope">
                        <p>{{scope.row.department || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="奖惩内容"
                        align="center"
                        prop="content">
                    <template scope="scope">
                        <p>{{scope.row.content || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="奖惩时间"
                        align="center"
                        prop="startTime">
                    <template scope="scope">
                        <p>{{scope.row.startTime | dateStrIntercept}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="奖励事由"
                        align="center"
                        prop="remark">
                    <template scope="scope">
                        <p>{{scope.row.remark || "--"}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="数据来源"
                        align="center"
                        prop="comeFrom">
                </el-table-column>
                <el-table-column
                        label="数据状态"
                        align="center"
                        prop="state">
                    <template scope="scope">
                        <p type="text" v-if="scope.row.state == 1" class="change-examine"><i class="examine-effective"></i><span>有效</span></p>
                        <p type="text" v-else-if="scope.row.state == 2" class="change-examine"><i class="examine-waitSubmit"></i><span>待生效</span></p>
                        <p type="text" v-else-if="scope.row.state == 3" class="change-examine"><i class="examine-invalid"></i><span>已作废</span></p>
                        <p type="text" v-else-if="scope.row.state == 4" class="change-examine"><i class="examine-waitSubmit"></i><span>待提交</span></p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="登记日期"
                        align="center"
                        prop="createTime">
                    <template scope="scope">
                        <p>{{scope.row.createTime | dateStrIntercept}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                        label="作废日期"
                        align="center"
                        prop="cancelTime">
                    <template scope="scope">
                        <p>{{scope.row.cancelTime && scope.row.cancelTime.substring(0,11)}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="toogleExpandTrue(scope.row)">查看</el-button>
                        <el-button type="text" v-if="scope.row.state == 4" @click="deleteData(scope.row,'ruleForm')">删除</el-button>
                        <el-button type="text" v-if="scope.row.state == 1 || scope.row.state == 2" @click="voidData(scope.row)">作废</el-button>
                    </template>
                </el-table-column>
                <el-table-column type="expand" width="1">
                    <template slot-scope="props">
                        <el-form :model="ruleForm" :ref="'ruleForm'+props.$index" label-width="120px" style="position: relative" inline>
                            <el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="人员姓名 : " :prop="'tableList.'+props.$index+'.personnelName'" :rules="{required: true, message: '请选择姓名', trigger: 'change'}" size="small">
                                            <el-select v-if="props.row.state == 4" @change="nameSelectChange(props.row)" v-model="props.row.personnelName"
                                                       placeholder="请选择人员" clearable>
                                                <el-option
                                                        v-for="(item,index) in emList"
                                                        :key="index"
                                                        :label="item.empName"
                                                        :value="item.empName+','+item.id+'-'+item.idNumber">
                                                    <span style="float: left">{{ item.empName }}</span>
                                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.idNumber }}</span>
                                                </el-option>
                                            </el-select>
                                            <span v-if="props.row.state != 4">{{props.row.personnelName}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="证件号码 : " :prop="'tableList.'+props.$index+'.empCret'" :rules="{required: true, message: '请输入证件号码', trigger: 'blur'}" size="small">
                                            <el-input v-if="props.row.state == 4" v-model="props.row.empCret" placeholder="请输入"
                                                      clearable></el-input>
                                            <span v-if="props.row.state != 4">{{props.row.empCret}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="奖惩类型 : " :prop="'tableList.'+props.$index+'.recordType'" :rules="{required: true, message: '请输入奖惩类型', trigger: 'change'}" size="small">
                                            <el-select v-if="props.row.state == 4" v-model="props.row.recordType" placeholder="请选择" clearable>
                                                <el-option v-for="(item,index) in personnelRewardList"
                                                           :key="index"
                                                           :label="item.text"
                                                           :value="item.id">
                                                </el-option>
                                            </el-select>
                                            <span v-if="props.row.state != 4">{{props.row.recordTypeName}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="8">
                                        <el-form-item label="处理文件文号 : " :prop="'tableList.'+props.$index+'.fileNum'" :rules="{required: true, message: '请输入处理文件文号', trigger: 'blur'}" size="small">
                                            <el-input v-if="props.row.state == 4" v-model="props.row.fileNum" placeholder="请输入"
                                                      clearable></el-input>
                                            <span v-if="props.row.state != 4">{{props.row.fileNum}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="实施/认定部门 : " :prop="'tableList.'+props.$index+'.department'" :rules="{required: true, message: '请输入实施/认定部门', trigger: 'blur'}" size="small">
                                            <el-input v-if="props.row.state == 4" v-model="props.row.department" placeholder="请输入"
                                                      clearable></el-input>
                                            <span v-if="props.row.state != 4">{{props.row.department}}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="奖惩时间 : " :prop="'tableList.'+props.$index+'.startTime'" :rules="{required: true, message: '请选择奖惩时间', trigger: 'change'}" size="small">
                                            <el-date-picker
                                                    v-if="props.row.state == 4"
                                                    v-model="props.row.startTime"
                                                    type="date"
                                                    placeholder="请选择日期时间">
                                            </el-date-picker>
                                            <span v-if="props.row.state != 4">{{props.row.startTime | dateStrIntercept}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <el-form-item label="奖惩内容 : " :prop="'tableList.'+props.$index+'.content'" :rules="{required: true, message: '请输入奖惩内容', trigger: 'blur'}" size="small">
                                            <el-input v-if="props.row.state == 4" v-model="props.row.content" placeholder="请输入"
                                                      clearable></el-input>
                                            <span v-if="props.row.state != 4">{{props.row.content}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <el-form-item label="奖励事由 : " :prop="'tableList.'+props.$index+'.remark'" :rules="{required: true, message: '请输入奖励事由', trigger: 'blur'}" size="small">
                                            <el-input v-if="props.row.state == 4" type="textarea" v-model="props.row.remark" placeholder="请输入"
                                                      clearable></el-input>
                                            <span v-if="props.row.state != 4">{{props.row.remark}}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-row>

                        </el-form>
                        <div class="bottom-btn" v-if="props.row.state == 4">
                            <el-button @click="deleteData(props.row,'ruleForm')">取消</el-button>
                            <el-button type="primary" @click="preservation(props.row,'ruleForm',props.$index)">保存</el-button>
                        </div>
                        <span @click="toogleExpandFalse(props.row)"
                              style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;">
                                    收起<i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
                                </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    export default {
        name: "qualification-information-personnel",
        data(){
            return{
                getRowKeys(row) {
                    return row.id
                },
                // 要展开的行，数值的元素是row的key值
                expands: [],
                ruleForm: {
                    tableList: [],
                },
                currentPage:1,
                pageSize:10,
                total:0,
                emList:[],
                queryParameter:{
                    attachmentParamList:[],
                    id:'',
                    entId:'',
                    entRoleCode	:'',
                    personnelName:'',
                    recordType :'',
                    startTime:'',
                    endTime:'',
                    state:'',
                    remark:'',
                    delFlag:'',
                    createUser:'',
                    createTime:'',
                    updateUser:'',
                    updateTime:'',
                    department:'',
                    content:'',
                    type:'',
                    cancelFlag:'',
                    cancelTime:'',
                    empCret:'',
                    fileNum:'',
                    comeFrom:'',
                }
            }
        },
        computed:{
            ...mapState({
                personnelRewardList: (state) => state.dataDictionary.personnelRewardList,
            })
        },
        created() {
            this.getRouterQuery();
            this.querData();
            this.$store.dispatch('dataDictionary/getPersonnelRewardList');//获取人员奖励类型
        },
        activated() {
            this.getRouterQuery();
            this.querData();
            this.$store.dispatch('dataDictionary/getPersonnelRewardList');//获取人员奖励类型
        },
        methods: {
            getRouterQuery(){
                this.id = this.$route.params.changeId;
                this.dataId = this.$route.params.id;
            },
            // 获取数据
            querData(){
                this.$http.post('/change/hentpersonnelrewardspunishmentrecords/list',{
                    page:this.currentPage,
                    rows:this.pageSize,
                    filter:{
                        entId:this.id
                    },
                    searchKey: '',
                    orderBy:'create_time desc'
                }).then((res)=>{
                    if(res.data){
                        this.ruleForm.tableList = res.data.rows;
                        this.total = res.data.total;
                        if(this.ruleForm.tableList.length && !this.ruleForm.tableList[0].fileNum){
                            this.expands.push(this.ruleForm.tableList[0].id)
                        }else{
                            this.expands = [];
                        }
                        this.ruleForm.tableList.forEach((item,index)=>{
                            item.startTime = item.startTime ? item.startTime.replace(/-/g,'/') : '';
                            item.createTime = item.createTime ? item.createTime.replace(/-/g,'/') : '';
                            item.cancelTime = item.cancelTime ? item.cancelTime.replace(/-/g,'/') : '';
                        })
                        this.querEmList();
                    }
                })
            },
            // 获取人员
            querEmList(){
                this.$http.post('/change/hentempinfo/list',{
                    page: 1,
                    rows: 80,
                    filter:{
                        entId:this.id,
                        state: '3'
                    },
                    searchKey: '',
                    orderBy:'create_time desc'
                }).then((res)=>{
                    if(res.data){
                        this.emList = res.data.rows;
                    }
                })
            },
            // 新增
            saveData() {
                for(let key in this.queryParameter){
                    if(key == 'attachmentParamList'){
                        this.queryParameter[key] = []
                    }else{
                        this.queryParameter[key] = ''
                    }
                }
                this.queryParameter.entId=this.id;
                this.queryParameter.state=4;
                this.$http.post('/change/hentpersonnelrewardspunishmentrecords/save',this.queryParameter).then((res)=>{
                    if(res.data.code == 1){
                        this.querData();
                    }else{
                        this.$message({
                            message: res.data.msg,
                            type: 'warning'
                        });
                        this.querData();
                    }
                });
            },
            // 删除/取消
            deleteData(row) {
                this.$http.post('/change/hentpersonnelrewardspunishmentrecords/delete?id='+row.id).then((res)=>{
                    if(res.data.code ==1){
                        this.querData();
                    }
                });
            },
            // 查看
            toogleExpandTrue(row) {
                this.$refs.table.toggleRowExpansion(row,true)
            },
            // 收起
            toogleExpandFalse(row) {
                this.$refs.table.toggleRowExpansion(row,false)
            },
            // 作废
            voidData(row) {
                this.$http.post('/change/hentpersonnelrewardspunishmentrecords/cancel?id='+row.id).then((res)=>{
                    if(res.data.code ==1){
                        this.querData();
                    }
                });
            },
            // 保存
            preservation(row, formName,index) {
                this.$refs['ruleForm'+index].validate((valid) => {
                    if (valid) {
                        this.queryParameter.entId= this.id;
                        this.queryParameter.state= row.state;
                        this.queryParameter.id= row.id;
                        this.queryParameter.personnelName= row.personnelName;
                        this.queryParameter.empCret= row.empCret;
                        this.queryParameter.recordType= row.recordType;
                        this.queryParameter.fileNum= row.fileNum;
                        this.queryParameter.department= row.department;
                        this.queryParameter.content= row.content;
                        this.queryParameter.startTime= row.startTime;
                        this.queryParameter.remark= row.remark;
                        this.queryParameter.entEmpId = !!this.queryParameter.entEmpId ? this.queryParameter.entEmpId.split(',')[1] : this.queryParameter.entEmpId;
                        this.$http.post('/change/hentpersonnelrewardspunishmentrecords/save',this.queryParameter).then((res)=>{
                            if(res.data.code == 1){
                                this.querData();
                                this.$refs.table.toggleRowExpansion(row,false)
                                this.$notify({
                                    title: '保存',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'success'
                                })
                            }else{
                                this.$notify({
                                    title: '保存',
                                    message: res.data.msg,
                                    position: 'bottom-right',
                                    type: 'warning'
                                })
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            },
            nameSelectChange(row){
                if(!!row.personnelName){
                    row.empCret = row.personnelName.split('-')[1];
                    this.queryParameter.entEmpId = row.personnelName.split('-')[0];
                    row.personnelName = row.personnelName.split(',')[0];
                }
            }
        },
        filters:{
            dateStrIntercept(str){
                if(str && str.length > 0){
                    return str.substring(0,11);
                }else{
                    return '--'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-textarea__inner {
        width: 810px;
        height: 80px;
    }
    .card-content {
        .card-content-search {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            padding-top: 4px;
            margin-right: 12px;

            .card-content-search-input {
                width: 250px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 2px;
                outline: none;
            }

            .card-content-search-btn {
                width: 70px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 32px;
                cursor: pointer;
            }

            .card-content-search-add {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
            }
            .card-content-search-add-able {
                width: 82px;
                height: 32px;
                background: #1890FF;
                border: none;
                border-radius: 2px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                cursor: pointer;
                line-height: 32px;
                margin-left: 12px;
                opacity: 25%;
            }
        }

        .card-content-table {
            margin: 16px 12px 0 12px;
            /deep/ .el-input__inner {
                width: 324px;
            }
        }
    }
    @media screen and (max-width: 1600px){
        /deep/ .el-textarea__inner {
            width: 965px;
            height: 80px;
        }
        .card-content{
            .card-content-table {
                margin: 16px 12px 0 12px;
                /deep/ .el-input__inner {
                    width: 200px;
                }
            }
        }
    }
</style>